import { render } from "./AnnouncementBar.vue?vue&type=template&id=cb5bf87e&scoped=true"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"

import "./AnnouncementBar.vue?vue&type=style&index=0&id=cb5bf87e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5bf87e"]])

export default __exports__